module.exports = __webpack_public_path__ + "media/images/iconRight__inFrontOfAccent-0747def74b2f206e9e566c26ec1c043a.png";